import type { SVGProps } from 'react';

export function LinkedIn({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <rect x="3" y="3" width="18" height="18" rx="2" />
      <path d="M8 10v7" />
      <circle cx="8" cy="7" r="1" fill="currentColor" />
      <path d="M13 17v-4a2 2 0 0 1 4 0v4" />
      <path d="M13 10v7" />
    </svg>
  );
}
